import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";

const LINES = [
    { text: "const seuNegocio = {", cls: "text-slate-300" },
    { text: '  nome: "Sua Empresa",', cls: "text-cyan-300" },
    { text: '  site: "moderno e rápido",', cls: "text-cyan-300" },
    { text: '  cardapio: "digital próprio",', cls: "text-cyan-300" },
    { text: "  comissaoDeApps: 0,", cls: "text-emerald-400" },
    { text: '  suporte: "direto no WhatsApp",', cls: "text-cyan-300" },
    { text: "};", cls: "text-slate-300" },
    { text: "", cls: "" },
    { text: "await strondex.publicar(seuNegocio);", cls: "text-amber-300" },
    { text: "// ✓ no ar, sem taxas, em poucos dias", cls: "text-slate-500" },
];

const TOTAL = LINES.reduce((s, l) => s + l.text.length + 1, 0);

export const CodeWindow = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress >= TOTAL) {
            const t = setTimeout(() => setProgress(0), 4200);
            return () => clearTimeout(t);
        }
        const t = setTimeout(() => setProgress((p) => p + 1), 32);
        return () => clearTimeout(t);
    }, [progress]);

    let used = 0;
    const rendered = LINES.map((l) => {
        const start = used;
        used += l.text.length + 1;
        const chars = Math.max(0, Math.min(l.text.length, progress - start));
        return { ...l, shown: l.text.slice(0, chars), started: progress > start };
    });

    const done = progress >= TOTAL;

    return (
        <div className="animate-float-slow relative rounded-2xl border border-white/10 bg-[#0D121F]/95 shadow-[0_30px_80px_rgba(0,0,0,0.55)] backdrop-blur-xl">
            <div className="flex items-center gap-1.5 border-b border-white/[0.07] px-4 py-3">
                <span className="h-2.5 w-2.5 rounded-full bg-red-400/80" />
                <span className="h-2.5 w-2.5 rounded-full bg-yellow-400/80" />
                <span className="h-2.5 w-2.5 rounded-full bg-[#25D366]/80" />
                <span className="ml-3 rounded-md bg-white/[0.06] px-3 py-1 font-mono text-[10px] text-slate-400">
                    deploy-do-seu-negocio.js
                </span>
            </div>

            <div className="min-h-[260px] p-5 font-mono text-[13px] leading-6 sm:text-sm">
                {rendered.map((l, i) =>
                    l.started ? (
                        <p key={i} className={`whitespace-pre ${l.cls}`}>
                            {l.shown}
                            {!done && i === rendered.findIndex((r) => r.shown.length < r.text.length && r.started) && (
                                <span className="ml-0.5 inline-block h-4 w-2 animate-pulse bg-cyan-400 align-middle" />
                            )}
                        </p>
                    ) : (
                        <p key={i} className="whitespace-pre">&nbsp;</p>
                    ),
                )}
                {done && (
                    <p className="mt-3 flex items-center gap-2 text-[12px] font-bold text-[#25D366]">
                        <Rocket size={14} />
                        Deploy concluído com sucesso
                    </p>
                )}
            </div>

            <div className="flex items-center justify-between border-t border-white/[0.07] px-4 py-2.5 font-mono text-[10px] text-slate-500">
                <span>strondex.tech — engenharia de verdade</span>
                <span className={done ? "text-[#25D366]" : "text-amber-300"}>{done ? "● online" : "● construindo..."}</span>
            </div>

            <div className="absolute -bottom-5 -left-4 flex items-center gap-2 rounded-full border border-[#25D366]/40 bg-[#0D121F] px-4 py-2 shadow-[0_10px_30px_rgba(37,211,102,0.25)]" data-testid="hero-visual-badge">
                <span className="beacon-dot h-2 w-2 rounded-full bg-[#25D366]" />
                <span className="text-xs font-extrabold text-slate-100">Sites · Cardápios · TI</span>
            </div>
        </div>
    );
};
